import React from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { fetchUsersTxInsights } from '../../actions'
import { disableCountryFilter, enableCountryFilter } from '../../actions/country_filter'
import { countryCodes } from './country_codes'

const CountryFilter = (props) => {
  const defaultFilter = 'Country: All'

  const handleSelectFilter = (e) => {
    const country = e.target.value === defaultFilter ? null : e.target.value
    props.updateFilter(country)
  }

  const selectedFilter = props.filter ? props.filter : defaultFilter
  return (
    <div className='form-group'>
      <select value={selectedFilter} name='country' id='country' className='form-control' onChange={handleSelectFilter}>
        <option key={defaultFilter} defaultValue={defaultFilter}>
          {defaultFilter}
        </option>
        {countryCodes.map((country) => (
          <option key={`${country.code}${country.name}${country.label}`} value={country.name}>
            {`${country.name}  ${country.label}`}
          </option>
        ))}
      </select>
    </div>
  )
}

const mapStateToProps = (state) => ({
  searchTerm: state.transactionSearch.searchTerm,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      disableCountryFilter,
      enableCountryFilter,
      fetchUsersTxInsights,
      navigateToPage: (p) => ownProps.history.push('#/page/' + p),
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CountryFilter))
